<template>
  <b-modal
    id="mobile-modal"
    ok-only
    modal-class="modal-warning"
    centered
    title="تنويه"
    ref="mobileModal"
    ok-variant="warning"
    ok-title="متابعة"
    presistant
    @ok="handleOk"
    no-close-on-backdrop
  >
    <b-card-text class="text-align-justify">
      <p style="line-height: 2rem; font-size: 12pt">
        باستخدامك لجهاز ذو حجم شاشة أصغر من 1100 بيكسل قد لا تعمل كل وظائف
        المنصة بالشكل المطلوب .<br />
        يفضل استخدام جهاز ذو حجم شاشة أكبر للحصول على أفضل تجربة استخدام لمنصة
        تشارك.
      </p>
      <div class="w-100 my-3 d-flex justify-content-center">
        <img
          height="250"
          :src="require('@/assets/images/illustration/mobile-responsive.svg')"
          alt="alert mobile illustration"
        />
      </div>
      <b-form-checkbox
        v-model="dontShowAgain"
        class="custom-control-warning my-1"
      >
        عدم عرض مربع الحوار هذا مرة أخرى
      </b-form-checkbox>
    </b-card-text>
  </b-modal>
</template>

<script>
import { BModal, BCardText, BFormCheckbox } from "bootstrap-vue";
export default {
  components: {
    BModal,
    BCardText,
    BFormCheckbox,
  },
  data() {
    return {
      dontShowAgain: false,
    };
  },
  methods: {
    handleOk() {
      if (this.dontShowAgain) localStorage.setItem("hideMobileAlert", "true");
    },
  },
  mounted() {
    if (window.innerWidth <= 1100) {
      if (!localStorage.getItem("hideMobileAlert"))
        this.$refs.mobileModal.show();
    }
  },
};
</script>
